import { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type LinkButtonProps = {
  children: ReactNode
  url: string
}

export const LinkButton = ({ children, url }: LinkButtonProps) => {
  return (
    <LinkButtonWrapper href={url} target="_blank" rel="noopener noreferrer">
      {children}
    </LinkButtonWrapper>
  )
}

const LinkButtonWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px 15px;
  transition: all 0.25s ease;
  cursor: pointer;

  background-color: ${theme.colors.trialBlue};
  color: #fff;
  width: 300px;
  height: 47px;
  border: none;
  border-radius: 24px;
  font-size: 17px;
  font-weight: bold;

  &:hover {
    background-color: ${theme.colors.hoverLightBlue};
  }

  @media screen and (max-width: 1047px) {
    font-size: 18px;
    width: 100%;
  }
`
